import React, { useEffect, useRef } from "react";
import * as Text from "@/components/text";
import AnchorChip from "../lib/AnchorChip";
import useWindowSize from "@/hooks/useWindowSize";
import breakpoints from "@/constants/breakpoinst";

import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";

export default function MoviesCategories({
  selected,
  setSelected,
  categories = [
    "Sonidero",
    "Intersecciones",
    "Resistencias",
    "Retrovisor",
    "Pulsos",
    "Ambulantito",
    "Injerto",
    "Coordenadas",
  ],
}) {
  const windowSize = useWindowSize();
  const flickingRef = useRef(null);

  useEffect(() => {
    if (windowSize.width && flickingRef.current) {
      if (windowSize.width > breakpoints.lg) {
        flickingRef.current.disableInput();
      } else {
        flickingRef.current.enableInput();
      }
    }
  }, [windowSize, flickingRef]);

  return (
    <div className="my-5">
      <div className=" hidden flex-wrap gap-2 md:flex">
        {categories.map((category, i) => (
          <div key={i}>
            <AnchorChip
              onClick={() => setSelected(category)}
              active={category === selected}
            >
              {category}
            </AnchorChip>
          </div>
        ))}
      </div>
      <div className="md:hidden">
        <Flicking
          ref={flickingRef}
          circular={false}
          align="prev"
          className="m-0 flex flex-row flex-wrap"
          moveType="freeScroll"
          bound={true}
        >
          {categories.map((category, i) => (
            <div key={i} className="mr-2 ">
              <AnchorChip
                onClick={() => setSelected(category)}
                active={category === selected}
              >
                {category}
              </AnchorChip>
            </div>
          ))}
        </Flicking>
      </div>
    </div>
  );
}
